import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import CakeIcon from '@material-ui/icons/Cake'
import EventIcon from '@material-ui/icons/Event'
import HomeWorkIcon from '@material-ui/icons/HomeWork'
import PeopleIcon from '@material-ui/icons/People'
import { DataManager, Query, UrlAdaptor } from '@syncfusion/ej2-data'
import {
  Day,
  DragAndDrop,
  Inject,
  Month,
  Resize,
  ScheduleComponent,
  ViewDirective,
  ViewsDirective,
  Week,
  WorkWeek,
} from '@syncfusion/ej2-react-schedule'
import { push } from 'connected-react-router'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import PageLayout from '../../components/PageLayout'
import useTypedSelector from '../../hooks/useTypedSelector'
import schedule from '../../services/schedule'
import { StoreState } from '../../store'
import { getPeople } from '../../store/people/peopleActions'
import { PeopleActionTypes } from '../../store/people/peopleTypes'
import { corEvent, sendEmail } from '../../store/schedule/scheduleActions'
import BirthdayDay from '../birthday/BirthdayDay'
import BirthdayMonth from '../birthday/BirthdayMonth'
import { useMediaQuery } from '@material-ui/core'
import { useStyles } from './style'

let data = new DataManager({
  url: `${schedule}/GetData`,
  crudUrl: `${schedule}/BatchData`,
  adaptor: new UrlAdaptor(),
  crossDomain: true,
})

let idChurch = ''
let emailUser = ''
let churchName = ''

export function getScheduleItem(): ThunkAction<
  Promise<void>,
  StoreState,
  undefined,
  Action
> {
  return async (dispatch, getState) => {
    const { selectedChurchIndex, user } = getState().sessionState
    const churchId = user?.churches?.[selectedChurchIndex]?.id
    idChurch = churchId
    const email = user?.email
    emailUser = email
    const name = user?.churches?.[selectedChurchIndex]?.name
    churchName = name
  }
}

export default function DashboardDetails() {
  const people = useTypedSelector(({ peopleState }) => peopleState.people)
  const matches = useMediaQuery('(min-width: 768px)')

  const reducerPeople = useMemo(() => {
    return people.reduce((acc, cur) => {
      if (cur.email !== '') {
        acc.push({ name: cur.name, email: cur.email })
      }
      return acc
    }, [])
  }, [people])

  const classes = useStyles()
  const dispatch = useDispatch()
  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  let churchObject = [
    { timeZone: timeZone },
    { idChurch: idChurch },
    { emailUser: emailUser },
    { churchName: churchName },
    ...reducerPeople,
  ]

  const { loading, panelsData, roles } = useTypedSelector(
    ({ dashboardState, sessionState }) => ({
      loading: dashboardState.loading,
      panelsData: dashboardState.panelsData,
      roles: sessionState.user?.roles || [],
    })
  )

  let dataQuery = new Query()
    .from('Events')
    .addParams('churchObject', JSON.stringify(churchObject))

  useEffect(() => {
    dispatch(getScheduleItem())
  }, [dispatch])

  if (loading) {
    return null
  }
  const onMountPage = () => dispatch(getPeople())
  const onUnmountPage = () => dispatch({ type: PeopleActionTypes.CLEAR })

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        overflowY: 'scroll',
      }}
    >
      <Grid container>
        {roles.includes('transactions') && (
          <Grid item xs={12} md={3}>
            <div
              className={classes.infobox}
              style={{ backgroundColor: '#3f51b5', cursor: 'pointer' }}
              onClick={() => dispatch(push('/agenda'))}
            >
              <div className={classes.infoboxIconContainer}>
                <EventIcon className={classes.infoboxIcon} />
              </div>
              <div className={classes.infoboxContent}>
                <Typography variant="h6">Agenda</Typography>
              </div>
            </div>
          </Grid>
        )}
        {roles.includes('transactions') && (
          <Grid item xs={12} md={3}>
            <div
              className={classes.infobox}
              style={{ backgroundColor: '#ed5564', cursor: 'pointer' }}
              onClick={() => dispatch(push('/lancamentos'))}
            >
              <div className={classes.infoboxIconContainer}>
                <AttachMoneyIcon className={classes.infoboxIcon} />
              </div>
              <div className={classes.infoboxContent}>
                <Typography variant="h6">Lançamentos</Typography>
              </div>
            </div>
          </Grid>
        )}
        {roles.includes('people') && (
          <Grid item xs={12} md={3}>
            <div
              className={classes.infobox}
              style={{ backgroundColor: '#1ab394', cursor: 'pointer' }}
              onClick={() => dispatch(push('/membros'))}
            >
              <div className={classes.infoboxIconContainer}>
                <PeopleIcon className={classes.infoboxIcon} />
              </div>
              <div className={classes.infoboxContent}>
                <Typography variant="h6">Membros</Typography>
                <Typography>{panelsData?.members}</Typography>
              </div>
            </div>
          </Grid>
        )}

        <Grid item xs={12} md={3}>
          <div
            className={classes.infobox}
            style={{ backgroundColor: '#1c83c6' }}
          >
            <div className={classes.infoboxIconContainer}>
              <HomeWorkIcon className={classes.infoboxIcon} />
            </div>
            <div className={classes.infoboxContent}>
              <Typography variant="h6">Igrejas</Typography>
              <Typography>{panelsData?.churches}</Typography>
            </div>
          </div>
        </Grid>
      </Grid>
      {matches ? (
        <Grid container>
          <Grid item xs={12} md={6}>
            <div
              className={classes.infobox}
              style={{
                cursor: 'pointer',
                color: '#000',
                backgroundColor: '#EC9647',
              }}
            >
              <div className={classes.infoboxContent}>
                <Box
                  display="flex"
                  flex={1}
                  justifyContent="space-between"
                  style={{ backgroundColor: '#fff', width: '100%' }}
                >
                  <ScheduleComponent
                    eventSettings={{ dataSource: data, query: dataQuery }}
                    width="100%"
                    height={matches ? '600px' : '400px'}
                    selectedDate={new Date()}
                    locale="pt"
                    popupOpen={sendEmail}
                    eventRendered={corEvent}
                  >
                    <ViewsDirective>
                      <ViewDirective
                        option="Day"
                        displayName="Hoje"
                        interval={matches ? 2 : 1}
                      />
                    </ViewsDirective>
                    <Inject
                      services={[
                        Day,
                        Week,
                        WorkWeek,
                        Month,
                        Resize,
                        DragAndDrop,
                      ]}
                    />
                  </ScheduleComponent>
                </Box>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div
              onClick={() => dispatch(push('/birthday'))}
              className={classes.infobox}
              style={{
                cursor: 'pointer',
                color: '#000',
                backgroundColor: '#1ab394',
              }}
            >
              <div className={classes.infoboxIconContainer}>
                <PageLayout
                  details={<></>}
                  onMountPage={onMountPage}
                  onUnmountPage={onUnmountPage}
                />
                <div style={{ display: 'block', position: 'relative' }}>
                  <CakeIcon className={classes.infoboxIcon} />
                  <p
                    style={{
                      position: 'absolute',
                      transformOrigin: 20,
                      transform: `rotate(90deg)`,
                      fontSize: 25,
                      color: '#fff',
                    }}
                  >
                    Aniversariantes
                  </p>
                </div>
              </div>

              <div className={classes.infoboxContent}>
                <div
                  style={{
                    backgroundColor: '#1ab394',
                    color: '#FFF',
                    width: '100%',
                    height: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography variant="h6">Hoje</Typography>
                </div>
                <div
                  style={{
                    backgroundColor: '#fff',
                    width: '100%',
                    height: 250,
                    overflowY: 'scroll',
                  }}
                >
                  <BirthdayDay />
                </div>
                <div
                  style={{
                    backgroundColor: '#1ab394',
                    color: '#FFF',
                    width: '100%',
                    height: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography variant="h6">Mês</Typography>
                </div>
                <div
                  style={{
                    backgroundColor: '#fff',
                    width: '100%',
                    height: 250,
                    overflowY: 'scroll',
                  }}
                >
                  <BirthdayMonth />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      ) : (
        ''
      )}
    </div>
  )
}
